"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reactModal;

var _reactDom = require("react-dom");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_DESTRUCTION_DELAY = 300;
var DEFAULT_OPTIONS = {
  destructionDelay: DEFAULT_DESTRUCTION_DELAY
};

var noop = function noop() {};

function reactModal(renderModal) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _DEFAULT_OPTIONS$opti = _objectSpread({}, DEFAULT_OPTIONS, options),
      destructionDelay = _DEFAULT_OPTIONS$opti.destructionDelay;

  var container = document.createElement('div');
  document.body.appendChild(container);

  function displayModal(_ref) {
    var onSubmit = _ref.onSubmit,
        onDismiss = _ref.onDismiss;
    (0, _reactDom.render)(renderModal({
      onSubmit: onSubmit,
      onDismiss: onDismiss,
      show: true
    }), container);
  }

  function hideModal(_ref2, callback) {
    var onSubmit = _ref2.onSubmit,
        onDismiss = _ref2.onDismiss;
    (0, _reactDom.render)(renderModal({
      onSubmit: onSubmit,
      onDismiss: onDismiss,
      show: false
    }), container, callback);
  }

  function destroyModal() {
    (0, _reactDom.unmountComponentAtNode)(container);
    document.body.removeChild(container);
  }

  var confirmation = new Promise(function (resolve) {
    var onSubmit = function onSubmit() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return resolve(value);
    };

    var onDismiss = function onDismiss() {
      return resolve(undefined);
    };

    displayModal({
      onSubmit: onSubmit,
      onDismiss: onDismiss
    });
  });
  return confirmation.finally(function () {
    var onSubmit = noop;
    var onDismiss = noop;
    hideModal({
      onSubmit: onSubmit,
      onDismiss: onDismiss
    }, function () {
      setTimeout(destroyModal, destructionDelay);
    });
  });
}

